import {
  types,
  NotificationsActionsType,
  INotifications,
} from '../types/notifications'

export const initialState: INotifications = {
  open: false,
  message: '',
}

export const notifications = (
  state = initialState,
  action: NotificationsActionsType
): INotifications => {
  switch (action.type) {
    case types.NOTIFICATION_DISPLAY:
      return {
        ...state,
        open: true,
        message: action.message,
        correlationId: action.correlationId,
      }
    case types.NOTIFICATION_CLOSE:
      return initialState
    default:
      return state
  }
}
